import React from "react";
import INR from "../../../../../assets/images/INR.webp";
import Reload from "../../../../../assets/icons/Reload";
// import useCounterStore from "../../store/store";
import "./BetPreview.css";
import useCounterStore from "../../../../../store/store";

const BetPreview = () => {
  const { winLoseCount, liveWageredStatus,resetWinLoseCountAction } = useCounterStore((state) => state);

  const { win, lose } = winLoseCount;
  const { wagered, profit } = liveWageredStatus;

  const handleReset = () => {
    resetWinLoseCountAction();
  };

  return (
    <div className="bet-preview-wrapper">
      <div className="bet-preview-container">
        <div className="bet-preview-header">
          <span className="bet-title">Bet</span>
          <div className="reload-icon" onClick={handleReset}>
            <Reload fill={"#b3bec1"} />
          </div>
        </div>

        <div className="bet-summary">
          <div className="left-column">
            <div className="summary-block">
              <span className="label">Profit</span>
              <div className="summary-value">
                <img src={INR} alt="INR" width="16px" height="16px" />
                <span
                  className={`value ${
                    profit < 0
                      ? "text-red"
                      : profit > 0
                      ? "text-purple"
                      : "text-white"
                  }`}
                >
                  {profit < 0 ? `- ₹${Math.abs(profit)}` : `₹${profit}`}
                </span>
              </div>
            </div>

            <div className="summary-block">
              <span className="label">Wagered</span>
              <div className="summary-value">
                <img src={INR} alt="INR" width="16px" height="16px" />
                <span className="value text-white">₹{wagered}</span>
              </div>
            </div>
          </div>

          <div className="right-column">
            <div className="summary-block">
              <span className="label">WIN</span>
              <div className="summary-value">
                <span
                  className={`value ${win < 1 ? "text-white" : "text-purple"}`}
                >
                  {win}
                </span>
              </div>
            </div>

            <div className="summary-block">
              <span className="label">LOSE</span>
              <div className="summary-value">
                <span
                  className={`value ${lose < 1 ? "text-white" : "text-red"}`}
                >
                  {lose}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BetPreview;
